var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('AppListItemAddress',{attrs:{"address":_vm.pickup.location.address}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }